import { IToastrService, IToastOptions, IToast } from 'angular-toastr';

export class ToastrService {
  static $inject = [ 'toastr' ];

  constructor( private toastr: IToastrService ) {
  }

  public success( message: string, title?: string, options?: IToastOptions ): IToast {
    return this.toastr.success(message, title, options);
  }

  public info( message: string, title?: string, options?: IToastOptions ): IToast {
    return this.toastr.info(message, title, options);
  }

  public warning( message: string, title?: string, options?: IToastOptions ): IToast {
    return this.toastr.warning(message, title, options);
  }

  public error( message: string, title?: string, options?: IToastOptions ): IToast {
    return this.toastr.error(message, title, options);
  }

  public clear( toast: IToast ) {
    this.toastr.clear(toast);
  }


}



// WEBPACK FOOTER //
// ./app/core/services/toastr/toastr.service.ts